import React from 'react'
import { state$ } from '../../driver'
import { observeImmutable } from '../../../../Components/HOCs'
import { BusyIndicator as BusyIndicatorComponent } from '@mobi/component-library/Feedback/BusyIndicator'

export const BusyIndicator = observeImmutable(state$, ({ record }) => (
  <BusyIndicatorComponent isBusy={record.isBusy} />
))
